import React from "react";

import SubNavMenu from "../shared/subNavMenu";

const MenuWhyGVI = ({ menuItems, children }) => {
  return (
    <section className="bg-yellow-lighter dark:bg-gray-darker fixed w-full top-16 z-10 flex justify-center py-10 h-100 md:overflow-y-scroll lg:overflow-y-hidden">
      <div className="container flex w-10/12 flex-wrap lg:flex-nowrap">
        <div className="w-5/12 border-l-0 mr-12 lg:w-4/12">
          <div className="w-full gvi-dark-gray-color border-b pb-3 border-border-light dark:border-gray-lighter">
            <span className="h5 uppercase text-white active-link !px-0 pb-3">
              Why GVI
            </span>
          </div>
          <div className="w-full flex mt-11">
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
              {menuItems?.slice(0, 4).map((menu, idx) => {
                return (
                  <SubNavMenu
                    subTitle={menu.label}
                    subTitleClass={menu?.description}
                    subtitleLink={menu?.path ?? menu?.url}
                    className={`${menu?.cssClasses.join(" ")} ${
                      idx > 0 ? "" : ""
                    } `}
                    data={menu?.children?.nodes ?? menu?.children}
                    key={idx}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className="w-5/12 border-l-0 mr-12 lg:w-4/12">
          <div className="w-full gvi-dark-gray-color border-b pb-3 border-border-light dark:border-gray-lighter">
            <span className="h5 uppercase text-white active !px-0 pb-3">
              About us
            </span>
          </div>
          <div className="w-full flex mt-11">
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
              {menuItems?.slice(4, 9).map((menu, idx) => {
                return (
                  <SubNavMenu
                    subTitle={menu.label}
                    subTitleClass={menu?.description}
                    subtitleLink={menu?.path ?? menu?.url}
                    className={`${menu?.cssClasses.join(" ")} ${
                      idx > 0 ? "" : ""
                    } `}
                    data={menu?.children?.nodes ?? menu?.children}
                    key={idx}
                  />
                );
              })}
            </div>
          </div>
        </div>

        <div className="w-full pb-16 pt-4 lg:w-3/12 lg:pt-0">{children}</div>
      </div>
    </section>
  );
};

export default MenuWhyGVI;
